<div
  class="kwikui-input-otp-multiple-wrapper wrapper {{ config.containerClass }}"
  id="c_{{ componentKey }}"
  *ngIf="otpForm?.controls"
  [ngStyle]="config.containerStyles"
>
  <input
    (paste)="handlePaste($event)"
    [pattern]="config.allowNumbersOnly ? '\\d*' : ''"
    [type]="inputType"
    [disabled]="disabled"
    [readonly]="readOnly ?? false"
    [placeholder]="config?.placeholder || ''"
    [ngStyle]="config.inputStyles"
    [class.input-otp-disabled]="disabled"
    [class.input-otp-readonly]="readOnly ?? false"
    [class.input-otp-s]="config?.size === 's'"
    [class.input-otp-m]="config?.size === 'm'"
    [class.input-otp-l]="config?.size === 'l'"
    [class.input-otp-invalid]="invalid"
    class="input-otp {{ config.inputClass }}"
    autocomplete="one-time-code"
    *ngFor="let item of otpForm?.controls | keys; let i = index"
    [formControl]="otpForm.controls[item]"
    #inp
    id="otp_{{ i }}_{{ componentKey }}"
    (keyup)="onKeyUp($event, i)"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event, i)"
  />
</div>
